<template>
   <section class="margin" >
       <!-- <header class="flex">
      <h1>
          Our online sessions
      </h1>
      <img  src="../../assets/underline.png" alt="">
      <h4 >We offer transformative online and offline yoga classes for kids, aged three to fifteen. We focus on the <br> mind-body connect and making sure that both </h4>
 </header> -->

<div class="boxes">


<div class="box1">

 <img class="cutimage" src="../../assets/onlinecourse.png" alt="">

<div class="inside-box">
<h4 class="age">Online Course   3 - 5 year old</h4>
<img  src="../../assets/underline.png" alt="">
<h3>Bean Yoga</h3>
<button  @click="$router.push('BeanYoga')"> Enroll Now</button>
</div>
</div>


<div class="box2">
    <img class="cutimage" src="../../assets/onlinecourse.png" alt="">
<div class="inside-box">
    
<h4 class="age"> Online Course   5 - 9 year old</h4>
<img  src="../../assets/underline.png" alt="">
<h3>Pod Yoga</h3>
<button @click="$router.push('BeanYoga')">Enroll Now</button>
</div>
</div>

<div class="box3">
    <img class="cutimage" src="../../assets/onlinecourse.png" alt="">
<div class="inside-box">
<h4 class="age">Online Course   9 - 12 year old</h4>
<img  src="../../assets/underline.png" alt="">
<h3>Yoglings</h3>
<button @click="$router.push('BeanYoga')">Enroll Now</button>
</div>
</div>

<div class="box4">
    <img class="cutimage" src="../../assets/onlinecourse.png" alt="">
<div class="inside-box">
<h4 class="age">Online Course   12 - 16 year old</h4>
<img  src="../../assets/underline.png" alt="">
<h3>Yoga Blossons</h3>
<button @click="$router.push('BeanYoga')">Enroll Now</button>
</div>
</div>

</div>

<h1 class="empathy">
         Empathy . Curiosity . Authenticity . Creativity . Fun . Gamification . Spontaneity
      </h1>

      <div class="images">
          <img class="resize" src="../../assets/ourprograms1.png" alt="">
          <img class="resize" src="../../assets/ourprograms2.png" alt="">
          <img class="resize" src="../../assets/ourprograms3.png" alt="">
          <img class="resize" src="../../assets/ourprograms4.png" alt="">
      </div>

<img class="ourprogramsbottom" src="../../assets/ourprogramsbottom.png" alt="">
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
 .resize{
        margin-bottom: 17px;
 }
.ourprogramsbottom{
    margin-left: auto;
    margin-right: auto;
    min-width: 15%;
    display: block;
    margin-top: 125px;
}
    
.images{
        display: flex;
    justify-content: space-between;
    margin-top: 125px;
    flex-wrap: wrap;

}
.margin{
    margin-top: 170px;
}
.empathy{
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #4BA3C3;
        margin-top: 170px;
        text-align: center;
}
h3{
    font-family: Original Surfer;
font-weight: 100;
font-size: 25px;
color: white;
}
button{
     color: white;
    background-color: transparent;
    border: none;
    padding: 15px 60px;
    border-radius: 10px;
    cursor: pointer;
    border: 2px solid white;
    transition: 0.3s ease-in;
    z-index: 1000;

}
button:hover{
    background-color: white;
    color: #791E94;
}
.age{
    color: white;
    /* word-spacing: 1cm; */
    line-height: 1.5;
    font-weight: 300;
}
.cutimage{
    /* margin-left: -428px;
    margin-top: -76px; */
position: relative;
    left: 70px;
    top: -78px;
}
.inside-box{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 206px;
    flex-direction: column;
        /* margin-top: 88px; */
            position: relative;
    top: -77px;
}
.boxes{
    display: flex;
    width: 90%;
    margin: auto;
    justify-content: space-around;
    /* margin-top: 112px; */
    flex-wrap: wrap;
}
.flex{
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 228px;
    justify-content: space-evenly;
    text-align: center;
    margin-top: 150px;
}
h1{
    color: #791E94;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    font-size: 3rem;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
.box1, .box2, .box3, .box4{
    width: 304.11px;
height: 304.11px;
background: #791E94;
border-radius: 21.1187px;
    margin-bottom: 50px;
}


@media (max-width: 1080px){
    .boxes{
margin: 10px;
    }
    .box1{
        margin-bottom: 100px;
    }
    .box2{
        margin-bottom: 100px;
    }
    .box3{
        margin-bottom: 100px;
    }
    .box4{
        margin-bottom: 100px;
    }
   
}
@media (max-width: 650px){
 .resize{
        width: 100%;
    height: auto;
}
}
</style>